import React from "react";

const items = [
  { title: "City Rides", desc: "Fast, reliable rides around Kurunegala and beyond." },
  { title: "Airport Transfers", desc: "Fixed-price pickups to BIA and back." },
  { title: "Outstation Trips", desc: "Comfortable intercity hires with pro drivers." },
];

export default function Services() {
  return (
    <div className="section container">
      <h2 className="section-title">Our Services</h2>
      <div className="cards">
        {items.map((it) => (
          <div key={it.title} className="card">
            <h3>{it.title}</h3>
            <p>{it.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
